module.exports = __webpack_public_path__ + "static/media/portal.37432455.png";